<template>
  <div>
    <Header />
    <section
      id="comparer_form"
      class="px-4 pt-16 pb-32 overflow-hidden bg-gray-100"
    >
      <div class="max-w-6xl mx-auto">
        <ValidationObserver ref="form" style="display: block">
          <form class="flex" @submit.prevent="onSubmit()">
            <div class="md:w-3/4 w-full">
              <div class="md:flex punkta_comparer_user_data">
                <div class="text-2xl md:w-1/3 mb-7 md:mb-0">
                  Dane uczestnika <br />
                  wyjazdu
                </div>
                <div
                  v-if="otherParticipant.length > 0"
                  class="md:w-2/3 punkta_comparer_userbol"
                >
                  <div
                    v-for="(item, index) in otherParticipant"
                    :class="'box-' + index"
                    :key="item.id"
                  >
                    <validation-provider
                      :rules="{
                          required: item.isTravelParticipant ? true : false,
                        regex: /^[A-Za-ząćęśłńóżźĄĆĘŚŁŃÓŻŹ]+$/
                      }"
                      v-slot="{ errors, pristine }"
                    >
                      <div class="relative md:w-4/5 mb-5">
                        <input
                          class="w-full p-5 pr-10 text-sm placeholder-black bg-white rounded shadow-0-2-5"
                          type="text"
                          v-model="item.name"
                          :name="'inputNameParticipant[' + index + ']'"
                          placeholder="Imię"
                          @click="
                            sendEvent({
                              event: 'travelInsuranceCalculator',
                              action: 'Field Click',
                              label: '2 Step - Imię[' + (index + 1) + ']'
                            })
                          "
                        />
                        <StatusInput
                          v-if="!pristine || errors[0] ? true : false"
                          :passed="errors[0] ? false : true"
                        />
                      </div>

                      <div class="relative text-sm text-red-100 error">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                    <validation-provider
                      :rules="{
                        required: item.isTravelParticipant ? true : false,
                        regex: /^[A-Za-ząćęśłńóżźĄĆĘŚŁŃÓŻŹ -]+$/
                      }"
                      v-slot="{ errors, pristine }"
                    >
                      <div class="relative md:w-4/5 mb-5">
                        <input
                          class="w-full p-5 pr-10 text-sm placeholder-black bg-white rounded shadow-0-2-5"
                          type="text"
                          v-model="item.surname"
                          :name="'inputSurnameParticipant[' + index + ']'"
                          placeholder="Nazwisko"
                          @click="
                            sendEvent({
                              event: 'travelInsuranceCalculator',
                              action: 'Field Click',
                              label: '2 Step - Nazwisko[' + (index + 1) + ']'
                            })
                          "
                        />
                        <StatusInput
                          v-if="!pristine || errors[0] ? true : false"
                          :passed="errors[0] ? false : true"
                        />
                      </div>

                      <div class="relative text-sm text-red-100 error">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>

                    <validation-provider
                      :class="item.isTravelParticipant ? '' : 'hidden'"
                      :rules="{
                        required: item.isTravelParticipant ? true : false,
                        max_date: true
                      }"
                       v-slot="{ errors, pristine, touched }"
                    >
                      <!-- <label class="mb-2 text-sm comparer_date inline-block" for="clientDate"
                        >Data Urodzenia</label
                      >
                      <br /> -->
                      <div class="relative md:w-4/5 mb-5">
                        <!-- <input
                          :name="'inputDateParticipant[' + index + ']'"
                          v-model="item.date"
                          class="w-full p-5 pr-10 text-sm placeholder-black bg-white rounded shadow-0-2-5"
                          type="date"
                        /> -->
                        <date-picker max="2999-12-31"  :default-value="defaultDate"  placeholder="Data Urodzenia"    @click="sendEvent({event: 'travelInsuranceCalculator',action: 'Field Click',label:'2 Step - Data Urodzenia[' + (index + 1) +']'})" lang="pl" :clearable="false" format="DD/MM/YYYY" value-type="YYYY-MM-DD" :input-attr="{ name: 'inputDateParticipant[' + index + ']', id: 'inputDateParticipant[' + index + ']'}"   :input-class="'w-full p-5 pr-10 text-sm placeholder-black bg-white rounded shadow-0-2-5 not-italic'" v-model="item.date">
                          <StatusCalendar
                        slot="icon-calendar"
                        :pristine="pristine && !touched"
                        :passed="errors[0] ? false : true"
                      />
                        </date-picker>
                        <!-- <StatusInput
                          v-if="!pristine || errors[0] ? true : false"
                          :passed="errors[0] ? false : true"
                        /> -->
                      </div>

                      <div class="relative text-sm text-red-100 error">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                    <div
                      class="border-b border-black md:w-4/5 border-opacity-20 pb-11 mb-7"
                    >
                      <div class="mb-2">
                        Czy osoba jest uczestnikiem podróży
                      </div>
                      <div class="flex">
                        <label class="switch">
                          <div class="relative right-10">
                            {{ item.isTravelParticipant ? 'Tak' : 'Nie' }}
                          </div>
                          <input
                            type="checkbox"
                            v-model="item.isTravelParticipant"
                            :name="'inputIsTravelParticipant[' + index + ']'"
                            @click="
                              sendEvent({
                                event: 'travelInsuranceCalculator',
                                action: 'Field Click',
                                label:
                                  '2 Step - Czy osoba jest uczestnikiem podróży[' +
                                  (index + 1) +
                                  ']'
                              })
                            "
                          />
                          <span class="slider round"></span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mb-10 md:flex">
                <div class="md:w-1/3"></div>
                <div class="text-sm md:w-2/3">
                  <div
                    class="flex justify-between py-5 mb-12 bg-white rounded-lg md:w-4/5 shadow-0-2-5 px-7"
                  >
                    <div class="flex justify-center">
                      <img
                        class="self-center mx-1"
                        src="@/assets/img/punkta_comparer/addperson.svg"
                        alt="add person"
                      />
                      <div class="self-center mx-1">
                        Dodaj kolejną osobę, <br />
                        którą chcesz ubezpieczyć
                      </div>
                    </div>
                    <div
                      v-on:click="addParticipant"
                      class="flex justify-center py-4 border border-black rounded-lg cursor-pointer px-7"
                    >
                      <div class="self-center mx-1 text-xs font-bold">
                        Dodaj
                      </div>
                      <svg
                        class="self-center mx-1"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M14.25 8.25H9.75V3.75C9.75 3.55109 9.67098 3.36032 9.53033 3.21967C9.38968 3.07902 9.19891 3 9 3C8.80109 3 8.61032 3.07902 8.46967 3.21967C8.32902 3.36032 8.25 3.55109 8.25 3.75V8.25H3.75C3.55109 8.25 3.36032 8.32902 3.21967 8.46967C3.07902 8.61032 3 8.80109 3 9C3 9.19891 3.07902 9.38968 3.21967 9.53033C3.36032 9.67098 3.55109 9.75 3.75 9.75H8.25V14.25C8.25 14.4489 8.32902 14.6397 8.46967 14.7803C8.61032 14.921 8.80109 15 9 15C9.19891 15 9.38968 14.921 9.53033 14.7803C9.67098 14.6397 9.75 14.4489 9.75 14.25V9.75H14.25C14.4489 9.75 14.6397 9.67098 14.7803 9.53033C14.921 9.38968 15 9.19891 15 9C15 8.80109 14.921 8.61032 14.7803 8.46967C14.6397 8.32902 14.4489 8.25 14.25 8.25Z"
                          fill="black"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>

              <div class="md:flex">
                <div class="md:w-1/3"></div>
                <div class="md:w-2/3">
                  <div class="flex justify-between w-full md:w-4/5">
                    <router-link
                      to="/"
                      class="flex justify-center w-32 py-4 text-xs font-bold text-black border border-black rounded-lg comparer-button text-opacity-60 border-opacity-20 md:w-40"
                    >
                      <svg
                        class="self-center mx-1 svg-button"
                        width="16"
                        height="6"
                        viewBox="0 0 16 6"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0.556272 3.32599C0.591976 3.43105 0.645515 3.52704 0.713812 3.60844L2.58928 5.74828C2.73054 5.90945 2.92214 6 3.12191 6C3.32169 6 3.51328 5.90945 3.65454 5.74828C3.79581 5.5871 3.87517 5.3685 3.87517 5.14056C3.87517 4.91263 3.79581 4.69403 3.65454 4.53285L3.05439 3.85666L14.7498 3.85666C14.9488 3.85666 15.1396 3.76649 15.2803 3.60597C15.421 3.44545 15.5 3.22774 15.5 3.00073C15.5 2.77372 15.421 2.55601 15.2803 2.3955C15.1396 2.23498 14.9488 2.1448 14.7498 2.1448L3.0544 2.1448L3.65454 1.46861C3.72486 1.38904 3.78067 1.29437 3.81876 1.19007C3.85684 1.08577 3.87645 0.973891 3.87645 0.860897C3.87645 0.747904 3.85684 0.636029 3.81876 0.531725C3.78067 0.427422 3.72486 0.332755 3.65454 0.253185C3.58481 0.172959 3.50183 0.109283 3.41042 0.0658282C3.319 0.0223736 3.22095 8.3388e-07 3.12191 8.25222e-07C3.02288 8.16564e-07 2.92483 0.0223735 2.83341 0.0658282C2.74199 0.109283 2.65902 0.172959 2.58928 0.253185L0.713812 2.39302C0.645515 2.47442 0.591976 2.57041 0.556272 2.67548C0.48124 2.88386 0.48124 3.1176 0.556272 3.32599Z"
                          fill="black"
                        />
                      </svg>
                      <div class="mx-1">Wstecz</div></router-link
                    >

                    <button
                      type="submit"
                      class="flex justify-center w-32 py-4 text-xs font-bold text-white bg-orange-100 rounded-lg comparer-button md:w-40"
                    >
                      <div class="mx-1">Dalej</div>
                      <svg
                        class="self-center mx-1"
                        width="15"
                        height="6"
                        viewBox="0 0 15 6"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M14.9437 2.67401C14.908 2.56895 14.8545 2.47296 14.7862 2.39156L12.9107 0.251722C12.7695 0.0905471 12.5779 0 12.3781 0C12.1783 0 11.9867 0.0905471 11.8455 0.251722C11.7042 0.412898 11.6248 0.631499 11.6248 0.859435C11.6248 1.08737 11.7042 1.30597 11.8455 1.46715L12.4456 2.14334H0.750187C0.551225 2.14334 0.360412 2.23351 0.219725 2.39403C0.0790375 2.55455 0 2.77226 0 2.99927C0 3.22628 0.0790375 3.44399 0.219725 3.6045C0.360412 3.76502 0.551225 3.8552 0.750187 3.8552H12.4456L11.8455 4.53139C11.7751 4.61096 11.7193 4.70563 11.6812 4.80993C11.6432 4.91423 11.6236 5.02611 11.6236 5.1391C11.6236 5.2521 11.6432 5.36397 11.6812 5.46827C11.7193 5.57258 11.7751 5.66724 11.8455 5.74681C11.9152 5.82704 11.9982 5.89072 12.0896 5.93417C12.181 5.97763 12.2791 6 12.3781 6C12.4771 6 12.5752 5.97763 12.6666 5.93417C12.758 5.89072 12.841 5.82704 12.9107 5.74681L14.7862 3.60698C14.8545 3.52558 14.908 3.42959 14.9437 3.32452C15.0188 3.11614 15.0188 2.8824 14.9437 2.67401Z"
                          fill="white"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <Chat />
          </form>
        </ValidationObserver>
      </div>
    </section>
  </div>
</template>

<script>
import Header from './components/Header.vue'
import Chat from './components/Chat.vue'
import StatusInput from './components/StatusInput.vue'
import StatusCalendar from './components/StatusCalendar.vue'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/pl';


export default {
  components: {
    Header,
    Chat,
    StatusInput,
    DatePicker,
    StatusCalendar
  },
  data () {
    return {
      defaultDate: this.$moment(new Date()).subtract(30, 'years'),
      participants: 1,
      participantsMax: 1,
      otherParticipant: [],
      inputNameParticipant: [],
      inputSurnameParticipant: [],
      inputPeselParticipant: [],
      inputEmailParticipant: [],
      inputDateParticipant: [],
      inputIsTravelParticipant: []
    }
  },

  mounted () {
    this.$store.commit('setStep', 1)
    window.scrollTo(0, 0)
    if (!this.$store.state.clientTripParticipant) {
      this.addParticipant()
    }
    if (
      this.$store.state.othersParticipants &&
      this.$store.state.othersParticipants.length > 0
    ) {
      this.otherParticipant = this.$store.state.othersParticipants
      this.participants = this.$store.state.othersParticipants.length + 1
      this.participantsMax = this.$store.state.othersParticipants.length + 1
    }
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'travelInsuranceCalculator',
      action: 'Step Enter',
      label: '2'
    })
  },
  methods: {
    onSubmit () {
      this.$refs.form.validate().then(success => {

        if (!success) {
          const errors = Object.entries(this.$refs.form.errors)
          .map(([key, value]) => ({ key, value }))
          .filter(error => error["value"].length);
          if(this.$refs.form.refs[errors[0]["key"]]){
            this.$refs.form.refs[errors[0]["key"]].$el.scrollIntoView({
            behavior: "smooth",
            block: "start"
            });
          }
          return
        }

        let _this = this

        _this.$store.commit('setShowCustomModal', true)
        setTimeout(function () {
          _this.slideText(1)
        }, 100);
        // _this.$store.commit('setLoader', true)

        _this.$store.commit(
          'setOthersParticipants',
          this.$data.otherParticipant
        )

        let protection_scopes = []
        let clients = []

        if (_this.$store.state.winterSports) {
          protection_scopes.push('winter_sports')
        }
        if (_this.$store.state.highRiskSports) {
          protection_scopes.push('high_risk_sports')
        }
        if (_this.$store.state.chronicDiseases) {
          protection_scopes.push('chronic_diseases')
        }
        clients.push({
          insurer: true,
          firstname: _this.$store.state.clientName,
          surname: _this.$store.state.clientSurname,
          birth_date:
            _this.$store.state.clientTripParticipant &&
            _this.$store.state.clientDate
              ? _this.convertDate(_this.$store.state.clientDate)
              : '',
          phone: _this.$store.state.clientPhone,
          email: _this.$store.state.clientEmail,
          owner: _this.$store.state.clientTripParticipant ? true : false
        })
        _this.$store.state.othersParticipants.forEach(element => {
          if (element.isTravelParticipant) {
            clients.push({
              insurer: false,
              firstname: element.name,
              surname: element.surname,
              birth_date: element.isTravelParticipant
                ? _this.convertDate(element.date)
                : '',
              owner: element.isTravelParticipant ? true : false
            })
          }
        })
        _this.$store.commit('setClients', clients)

        const dataPost = {
          data: {
            id: '',
            type: 'calculation',
            attributes: {
              id: '',
              token: '',
              destination: _this.$store.state.location,
              protection_scopes: protection_scopes,
              email: _this.$store.state.clientEmail,
              phone: _this.$store.state.clientPhone,
              insurance_start_date: _this.convertDate(
                _this.$store.state.dateFrom
              ),
              insurance_end_date: _this.convertDate(_this.$store.state.dateTo),
              clients: clients,
              partners: ['fittravel'],
              requestor: 'client',
              agent_email: null,
              discounts: []
            }
          }
        }

        this.axios
          .post(
            // '/wp-json/travel/v1/getQuotations',
            '/wp-json/travel/v1/getQuotations',
            dataPost
          )
          .then(function (response) {
            if (response.status == 200 && response?.data?.calculation_token) {
              _this.getQuotationStatus(response.data.calculation_token)
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      })
    },
    addParticipant () {
      this.participants++
      this.participantsMax++
      this.otherParticipant.push({
        name: '',
        surname: '',
        date: '',
        isTravelParticipant: true
      })
    },
    convertDate (inputFormat) {
      function pad (s) {
        return s < 10 ? '0' + s : s
      }
      var d = new Date(inputFormat)
      return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join(
        '/'
      )
    },
    getQuotationStatus (calculation_token) {
      let _this = this
      var count = 0

      const cancelTokenSource = this.axios.CancelToken.source()
      var interval = setInterval(() => {
        this.axios
          .post(
            // '/wp-json/travel/v1/getQuotationStatus',
            '/wp-json/travel/v1/getQuotationStatus',
            {
              calculation_token: calculation_token
            },
            { cancelToken: cancelTokenSource.token }
          )
          .then(function (response) {
            count++
            if (response && response.data) {
              if (response.data == 1) {
                cancelTokenSource.cancel()
                clearInterval(interval)
                _this.getStarpacks(calculation_token)
              }
            }
            if (count > 90) {
              _this.$store.commit('setShowModal', true)
              // _this.$store.commit('setLoader', false)
              _this.$store.commit('setShowCustomModal', false)
              cancelTokenSource.cancel()
              clearInterval(interval)
            }
          })
          .catch(thrown => {
            if (!this.axios.isCancel(thrown)) {
              console.log(thrown)
              // _this.$store.commit('setLoader', false)
              _this.$store.commit('setShowModal', true)
              _this.$store.commit('setShowCustomModal', false)
            }
          })
      }, 1000)
    },
    getStarpacks (calculation_token) {
      let _this = this
      // _this.$store.commit('setLoader', true)
      this.axios
        .post(
          // '/wp-json/travel/v1/getStarpacks',
          '/wp-json/travel/v1/getStarpacks',
          { calculation_token: calculation_token }
        )
        .then(function (response) {
          if (response && response.data && response.data.code == 200) {
            _this.$store.commit(
              'setStarpacks',
              _this.getOffersOnListing(response.data.starpacks)
            )
            // _this.$store.commit('setLoader', false)
            _this.$store.commit('setShowCustomModal', false)
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({
              event: 'travelInsuranceCalculator',
              action: 'Step Enter',
              label: '3',
              calculationId: calculation_token //id kalkulacji
            })
            _this.$store.commit('setCalculationToken', calculation_token)
            _this.updateLead(calculation_token)
            _this.$router.push('offers')
          }
        })
        .catch(function (error) {
          console.log(error)
          // _this.$store.commit('setLoader', false)
          _this.$store.commit('setShowCustomModal', false)
          _this.$store.commit('setShowModal', true)
        })
    },
    updateLead (calculation_token) {
      let _this = this
      this.axios
        .post('/wp-json/travel/v1/updateLead', {
          lead: {
            salesforce_id: _this.$store.state.leadSalesforceId,
            calculation_token: calculation_token
          }
        })
        .catch(function (error) {
          console.log(error)
          // _this.$store.commit('setShowModal', true)
        })
    },
    getOffersOnListing (starpacks) {
      var tmpArray = []
      var protection_scopes = []

      if (this.$store.state.winterSports) {
        protection_scopes.push('ASZ')
      }
      if (this.$store.state.highRiskSports) {
        protection_scopes.push('ASWR')
      }
      if (this.$store.state.chronicDiseases) {
        protection_scopes.push('CHP')
      }
      if (protection_scopes.length > 0) {
        starpacks.forEach(starpack => {
          var counter = 0
          starpack?.result_info?.main_products.forEach(product => {
            if (protection_scopes.includes(product.code)) {
              counter++
            }
          })
          if (counter === protection_scopes.length) {
            tmpArray.push(starpack)
          }
        })
        if (tmpArray.length > 0) {
          tmpArray.sort(function (a, b) {
            return parseFloat(a.price) - parseFloat(b.price)
          })
        } else {
          tmpArray = this.getStarpacksWithoutProtectionScopes(starpacks)
        }
      } else {
        tmpArray = this.getStarpacksWithoutProtectionScopes(starpacks)
      }

      if (!tmpArray.length > 0) {
        // this.$store.commit('setLoader', false)
        this.$store.commit('setShowCustomModal', false)
        this.$store.commit('setShowModal', true)
      }

      return tmpArray
    },
    getPunktaTravelStarpack (starpacks) {
      var tmpArray = []

      starpacks.sort(function (a, b) {
        return parseFloat(a.price) - parseFloat(b.price)
      })

      starpacks.forEach(starpack => {
        if (starpack?.result_info?.name === 'Europ Assistance') {
          tmpArray.push(starpack)
        }
      })

      return tmpArray[0]
    },
    getStarpacksWithoutProtectionScopes (starpacks) {
      var tmpArray = []
      var punktaTravelStarpack = this.getPunktaTravelStarpack(starpacks)
      if (punktaTravelStarpack?.id_starpack) {
        tmpArray.push(punktaTravelStarpack)
      }

      starpacks.sort(function (a, b) {
        return parseFloat(a.price) - parseFloat(b.price)
      })
      starpacks.forEach(starpack => {
        if (starpack.id_starpack !== punktaTravelStarpack?.id_starpack) {
          tmpArray.push(starpack)
        }
      })

      return tmpArray
    },
    sendEvent (value) {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push(value)
    }
  }
}
</script>
